import './App.scss';

import HomePage from './Pages/HomePage';
import {Switch, Route} from 'react-router-dom';
import AboutPage from './Pages/AboutPage';
import PortfliosPage from './Pages/PortfoliosPage';
import BlogsPage from './Pages/BlogsPage';
import ContactPage from './Pages/ContactPage';
import { useState } from 'react';
import "./styles.css";
import countapi from 'countapi-js';
import HamburgerMenu from './Components/HamburgerMenu';

function App() {
  countapi.visits().then((result) => {
    console.log(result.value);
  });
  
 
  return (
    
    <div className="App">
     <HamburgerMenu/>
      
      <div className="main-content">
      
          <div className="content">
            <Switch>
              <Route path="/" exact>
               
               
     <HomePage />
              </Route>
              <Route path="/about" exact>
                <AboutPage />
              </Route>
              <Route path="/projects" exact>
                <PortfliosPage />
              </Route>
              <Route path="/education" exact>
                <BlogsPage />
              </Route>
              <Route path="/contact" exact>
                <ContactPage />
              </Route>
            </Switch>
          </div>
      </div>
    </div>
  );
}

export default App;
